import { RootState } from "@/shared/types";
import { ISamplesData, IGetManySamplesParams } from "./types/interfaces";

export const selectSamples = (state: RootState): ISamplesData =>
  state.samples.data;

export const selectMultiSamples = (state: RootState): ISamplesData =>
  state.samples.multiSamples;

export const selectAvailableSamples = (state: RootState): ISamplesData =>
  state.samples.availableSamples;

export const selectAvailableSamplesByLoinc = (state: RootState): ISamplesData =>
  state.samples.availableSamplesByLoinc;

export const selectParams = (state: RootState): IGetManySamplesParams =>
  state.samples.params;
